module.exports = __webpack_public_path__ + "img/243.d41d8cd9.svg";